import { RootState } from 'store/rootReducer';

export const RequestMarketingCardContentSelector = (state: RootState) => state.content.requestMarketingCard;
